/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:24:19
 * @modify date 2021-08-23 11:24:19
 * @desc [枚举]
 */

/**
 * @export 登陆类型
 * @enum
 */
export enum EnumLoginType {
  /** 手机号 */
  mobile = 'mobile',
  /** 账号 */
  account = 'account',
  /** 微信 */
  wechat = 'wechat',
  /** 注册 */
  registered = 'registered',
  /** 自动登录 */
  auto = 'auto',
  /** 开发者平台 */
  developer = 'developer',
  /** 密码code */
  pwdCode = 'pwdCode',
  /** lenovoid-code登录 */
  lenovoid = 'lenovoid',
  /** lenovoid注册登录 */
  lenovoidRegister = 'lenovoidRegister',
  /** 政企（大客户）注册 */
  relRegister = 'relRegister',
  /** SMB注册 */
  smbRegister = 'smbRegister',
}
export enum EnumCustomPlatform {
  /** 桌面PC */
  pc = 'pc',
  /** 桌面PC */
  desktop = 'desktop',
  /** 手机H5 */
  mobile = 'mobile',
  /** 小程序 */
  weapp = 'weapp',
  /** app */
  app = 'app',
}
/**
 * @export appId
 * @enum
 */
export enum EnumAppIdType {
  /** bpp */
  bpp = 'wxb2b6f0c690f6dbaf',
}
/**
 * @export 短信验证码发送场景
 * @enum
 */
export enum EnumPhoneMsgScene {
  /** 注册 */
  register = 1,
  /** 登录 */
  login = 2,
  /** 忘记密码 */
  editPwd = 3,
  /** 修改手机号 校验手机号 */
  editPhone = 4,
  /** 绑定新手机号 */
  bindPhone = 5,
  /** 微信绑定手机号 */
  wechatBindPhone = 6,
  /** 政企（大客户）注册 */
  relRegister = 7,
  /** 服务站账号激活 */
  serviceStation = 8,
  /** SMB注册 */
  smbRegister = 9,
  /** 窗口期内/外，绑定主账号安全手机号 */
  securityBindPhone = 2,
}
/**
 * @export 验证码类型
 * @enum
 */
export enum EnumCaptchaType {
  /** 短信验证码 */
  mobile = 1,
  /** 邮箱验证码 */
  email = 2,
}

/**
 * @export 图形验证码类型
 * @enum
 */
export enum EnumImgCodeType {
  /** account */
  account = 1,
  /** lenovoid */
  lenovoid = 2,
}

/**
 * @export 微信授权类型
 * @enum
 */
export enum EnumWechatAuthorizeState {
  /** 授权登录 */
  login = 'login',
}
export enum EnumStatusCode {
  /** 身份为sales */
  salesAuth = 4001,
  /** 未认证的l2 */
  L2Auth = 4002,
  /** 已认证-未绑定k码 l2 */
  bindKcode = 4003,
  /** 已认证-未绑定手机号 l2 */
  bindMobile = 4004,
  /** 个人中心-我的商机-sales权限 */
  salesToBu = 4005,
  /** 服务器错误 */
  serverError = 500,
  /** 404错误 */
  notFound = 404,
  /** 二维码超时 */
  qrcodeOverTime = 'Awechat-1005',
  /** 新用户 */
  newUser = 'AAuthorization-1017',
  /** 非法token */
  illegalToken = 'illegalToken',
  /** lenovoid非法token */
  lidIllegalToken = 'ALenovo-1000',
  /** 失效token */
  invalidToken = 'A0230',
  /** 10位账号下线报错 */
  tenNumAccountErr = 'AAuthorization-1003',
  /** 强制重置密码 */
  resetPwd = 'AUserData-1012'
}

/**
 * @export 登录来源
 * @enum
 */
export enum EnumLoginWay {
  /** 账号密码登录 */
  PWD_LOGIN = 1,
  /** 手机号登录 */
  SMS_LOGIN = 2,
  /** 微信登录 */
  WECHAT_LOGIN = 3,
  /** 切换登录 */
  SWITCH_LOGIN = 4,
  /** ITcode 登录 */
  AD_LOGIN = 5,
  /** 单点登录 */
  SSO_LOGIN = 6,
  /** lenovoid 登录 */
  LENOVO_LOGIN = 7,
}
